// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import learnEntity from './entities/learn.json';
import learnMenu from '../pages/learn/menu.json';
import learnFullForm from '../pages/learn/forms/full.json';
import learnContextForm from '../pages/learn/forms/context.json';
import learnMiniForm from '../pages/learn/forms/mini.json';
import learnLookupForm from '../pages/learn/forms/lookup.json';
import learnTableView from '../pages/learn/views/table.json';
import learnStagesView from '../pages/learn/views/stages.json';
import learnCardsView from '../pages/learn/views/cards.json';
import learnInlineView from '../pages/learn/views/inline.json';
import learnBacklogView from '../pages/learn/views/backlog.json';
import learnSplitView from '../pages/learn/views/split.json';
import learnCalendarView from '../pages/learn/views/calendar.json';
import learnDashboardView from '../pages/learn/views/dashboard.json';

/** Тип запису «Курс» зі сторінками пакета: меню, форми та подання з pages/learn/. */
export const learnDefinition: IRecordTypeDefinition = {
  ...learnEntity,
  views: assembleViewSet({
      table: learnTableView,
      stages: learnStagesView,
      cards: learnCardsView,
      inline: learnInlineView,
      backlog: learnBacklogView,
      split: learnSplitView,
      calendar: learnCalendarView,
      dashboard: learnDashboardView,
  }),
  form: learnFullForm,
  forms: { full: learnFullForm, context: learnContextForm, mini: learnMiniForm, lookup: learnLookupForm },
  menu: learnMenu,
} as IRecordTypeDefinition;
